var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Login"}},[_c('div',{staticClass:"handle"},[_c(_vm.componentName,{tag:"component",on:{"toogle":_vm.toogle}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }